<template>
  <div class="container__left">
    <AmCard class="container__left__card">
      <div class="am-steps">
        <div class="step" />
        <div class="step__content">
          <component
            :is="paymentTypeSelectedComponent"
            ref="payment"
            v-model="stepsData.payment"
            :paymentSuccessData="getPaymentDataOnSuccess"
            :installmentSelected="stepsData.payment.installments"
            :paymentType="currentPaymentTypeSelected"
            @paymentSelected="paymentSelected($event)"
            @paymentCardFinishPayment="paymentCardFinishPayment()"
            @refreshCodePix="paymentForPix()"
            @continuePaymentCard="continuePaymentCard()"
            @returnPaymentType="returnPaymentType()"
            @returnPaymentCardDataPayment="returnPaymentCardDataPayment()"
            @returnPaymentTypeErrorBilletOrPix="returnPaymentType()"
            @returnWithRecaptchaAttemptsCount="recaptchaAttemptsCount()"
          />
          <div
            v-show="hideNextStep"
            class="payment__button"
          >
            <AmButton
              v-if="hideButtonActionPayment"
              data-test="payment"
              :class="['next', disabledNextStep ? '' : theme.color]"
              :label="labelButtonPayment"
              size="xl"
              full-width
              :icon="iconPayment"
              :disabled="loadingGlobal"
              @click="paymentTypeSelectedAction()"
            >
              <template
                v-if="loadingGlobal"
                #content
              >
                <AmLoading
                  class="loading--white"
                  :AmLoaderSize="35"
                />
              </template>
            </AmButton>
          </div>
        </div>
      </div>
      <template
        v-if="hiddenButtonInProgress"
        #footer
      >
        <AmButton
          v-show="!hideNextStep"
          data-test="next_step"
          :label="$t('steps.nextStep')"
          :class="['next', disabledNextStep ? '' : theme.color]"
          size="xl"
          full-width
          :icon="iconNext"
          :disabled="disabledNextStep"
          @click="actionsPostSteps()"
        >
          <template
            v-if="loadingGlobal"
            #content
          >
            <AmLoading
              class="loading--white"
              :AmLoaderSize="35"
            />
          </template>
        </AmButton>
      </template>
    </AmCard>

    <Footer />
  </div>
</template>

<script>
import replaceSpecialCharactersMixin from '@/components/mixins/replaceSpecialCharactersMixin'
import themeMixin from '@/components/mixins/themeMixin'
import currencyFilterMixin from '@/components/mixins/currencyFilterMixin'
import { mapMutations, mapActions, mapState } from 'vuex'
import PaymentShopify from '@/views/Checkout/partials/steps/Payment/Shopify/PaymentShopify.vue'
import PaymentCard from '@/views/Checkout/partials/steps/Payment/payments/PaymentCard/PaymentCard.vue'
import PaymentBillet from '@/views/Checkout/partials/steps/Payment/payments/PaymentBillet/PaymentBillet.vue'
import PaymentPix from '@/views/Checkout/partials/steps/Payment/payments/PaymentPix/PaymentPix.vue'
import Payment from '@/views/Checkout/partials/steps/Payment/Payment.vue'
import Delivery from '@/views/Checkout/partials/steps/Delivery/Delivery.vue'
import ReviewContactAddress from '@/views/Checkout/partials/steps/Delivery/review/ReviewContactAddress/ReviewContactAddress.vue'
import PaymentBilletSuccess from '@/views/Checkout/partials/steps/Payment/payments/PaymentBillet/PaymentBilletSuccess/Shopify/PaymentBilletSuccess.vue'
import PaymentPixSuccess from '@/views/Checkout/partials/steps/Payment/payments/PaymentPix/PaymentPixSuccess/Shopify/PaymentPixSuccess.vue'
import PaymentCardOffer from '@/views/Checkout/partials/steps/Payment/payments/PaymentCard/PaymentCardOffer/PaymentCardOffer.vue'
import PaymentSuccess from '@/views/Checkout/partials/steps/Payment/PaymentSuccess/Shopify/PaymentSuccess.vue'
import PaymentError from '@/views/Checkout/partials/steps/Payment/PaymentError/PaymentError.vue'
import PaymentCardLoading from '@/views/Checkout/partials/steps/Payment/payments/PaymentCard/PaymentCardLoading/PaymentCardLoading.vue'
import DataCustomer from '@/views/Checkout/partials/steps/StepData/StepData.vue'

export default {
  name: 'ContainerLeft',
  components: {
    DataCustomer,
  },
  mixins: [themeMixin, replaceSpecialCharactersMixin, currencyFilterMixin],
  data() {
    return {
      paymentCardData: {},
      initialHistoryCount: 0,
      isHistoryBackClicked: false,
      backCounter: 0,
      currentStep: 2,
      paymentTypeSelectedComponent: PaymentShopify,
      currentPaymentTypeSelected: null,
      paymentTypeSelectedAction: () => {},
      hideButtonActionPayment: true,
      deliveryOrReviewData: Delivery,
      hideNextStep: false,
      hideReturnStepPayment: false,
      steps: [
        {
          title: this.$t('steps.titles[0]'),
        },
        {
          title: this.$t('steps.titles[1]'),
        },
        {
          title: this.$t('steps.titles[2]'),
        },
      ],
      stepsData: {
        identify: {
          full_name: null,
          telephone: null,
          email: null,
        },
        shipping: {
          postal_code: null,
          city: null,
          street: null,
          number: null,
          neighborhood: null,
          state: null,
          complement: null,
        },
        payment: {
          credit_card_number: null,
          name: null,
          document: null,
          credit_card_year: null,
          credit_card_month: null,
          credit_card_cvv: null,
          installments: {},
          recaptcha_response: null,
          recaptcha_attempts: 0,
          telephone: null,
        },
      },
      labelInstallmentsPrice: null,
      returnStepText: null,
      iconPayment: {
        name: 'local_mall',
        position: 'left',
        type: 'material',
        size: 'xl',
      },
      labelButtonPayment: null,
      iconNext: {
        name: 'chevron_right',
        position: 'right',
        type: 'material',
      },
      disabledNextStep: false,
      hiddenButtonInProgress: false,
    }
  },
  computed: {
    ...mapState('Checkout', {
      orderBumpsQuantity: (state) => state.cart.items.bundles[0]?.order_bumps.length,
      installmentDefault: (state) => state.cart.items.bundles[0]?.installments_default,
      installments: (state) => state.cart.installments,
      cartStatus: (state) => state.cart,
      loadingGlobal: (state) => state.globalLoading,
      getThemeColor: (state) => state.theme.color,
    }),
    getPaymentDataOnSuccess() {
      if (this.currentPaymentTypeSelected === 'card') {
        return this.paymentCardData
      }

      if (this.currentPaymentTypeSelected === 'billet') {
        return this.stepsData.payment
      }

      return this.stepsData.payment.pix
    },
  },
  watch: {
    currentStep() {
      if (this.currentStep === 2 && this.deliveryOrReviewData !== ReviewContactAddress) {
        this.currentStep = 1
        this.deliveryOrReviewData = ReviewContactAddress
      }

      this.disabledButtonPaymentTypeSelected()
    },
    paymentTypeSelectedComponent() {
      this.getCurrentStepStatus()
      if (this.paymentTypeSelectedComponent === PaymentShopify) {
        this.paymentCardSetLabel()
      }
    },
    currentPaymentTypeSelected() {
      if (this.currentPaymentTypeSelected) {
        this.actionsPostSteps()
        this.disabledNextStep = false
      }
    },
    stepsData: {
      deep: true,
      async handler() {
        if (
          this.paymentTypeSelectedComponent === PaymentShopify &&
          this.currentPaymentTypeSelected === 'card'
        ) {
          if (this.stepsData.payment.installments.label) {
            this.paymentSelected('card')
          } else {
            setTimeout(() => {
              if (this.installments.length) {
                this.paymentCardSetLabel()
              }
            }, 5000)
          }
        }
      },
    },
    cartStatus() {
      if (this.cartStatus.customer.id) {
        const { full_name: fullName, telephone } = this.cartStatus.customer
        let { email } = this.cartStatus.customer

        if (email && !this.cartStatus.settings.email_required) {
          email = email.slice(email.indexOf('@')).includes('appmax') ? '' : email
        }

        this.stepsData.identify = { full_name: fullName, telephone, email }
      }

      if (this.cartStatus.customer.postcode) {
        const {
          postcode,
          address_city: city,
          address_street: street,
          address_street_number: number,
          address_street_district: neighborhood,
          address_state: state,
          address_street_complement: complement,
        } = this.cartStatus.customer

        this.stepsData.shipping = {
          postal_code: postcode,
          city,
          street,
          number,
          neighborhood,
          state,
          complement,
        }
      }

      if (this.cartStatus.recaptcha_attempts) {
        this.stepsData.payment.recaptcha_attempts = this.cartStatus.recaptcha_attempts
      }
    },
    loadingGlobal() {
      if (this.loadingGlobal) {
        this.disabledNextStep = true
        return this.loadingGlobal
      }

      this.disabledNextStep = false
      return this.loadingGlobal
    },
    getThemeColor: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.hiddenButtonInProgress = true
        } else {
          this.hiddenButtonInProgress = false
        }
      },
    },
  },
  methods: {
    ...mapActions('Checkout', [
      'identify',
      'shipping',
      'fetchCep',
      'paymentBilletShopify',
      'paymentCreditCardShopify',
      'paymentPixShopify',
      'states',
      'createOrderShopify',
    ]),
    ...mapMutations('Checkout', ['SET_ENABLE_DISABLE_ADD_REMOVE_QUANTITY_BUNDLE']),
    disabledButtonPaymentTypeSelected() {
      if (this.paymentTypeSelectedComponent === Payment && this.currentStep === 2) {
        if (this.currentPaymentTypeSelected) {
          this.disabledNextStep = false
        } else {
          this.disabledNextStep = true
        }
      }
    },
    handlePaymentResponse(response) {
      setTimeout(() => {
        window.location.href = response.redirect_url
      }, 60000)
    },
    async nextStep() {
      const cuttenStep = this.currentStepEnable + 1

      if (cuttenStep === this.steps.length - 1) {
        this.finish()
      }

      if (cuttenStep < this.steps.length) {
        this.currentStepEnable += 1
        await this.setIndicatorActive()
        await this.setProgress()
        this.next()
      }
    },
    next() {
      this.$emit('next')
    },
    previous() {
      this.$emit('previous')
    },
    finish() {
      this.$emit('finish')
    },
    paymentCardSetLabel() {
      this.installments.map((installments) => {
        if (installments.installment === this.installmentDefault) {
          this.stepsData.payment.installments = {
            label: `${installments.installment}x de ${this.$options.filters.currencyBRL(
              installments.value
            )}`,
            id: this.installmentDefault,
          }
        }
        return installments
      })
    },
    paymentSelected(payment) {
      window.parent.postMessage(payment, '*')

      this.currentPaymentTypeSelected = payment

      const paymentAction = {
        card: () => this.paymentForCreditCard(),
        billet: () => this.paymentForBillet(),
        pix: () => this.paymentForPix(),
      }

      const paymentButtonIcon = {
        card: 'local_mall',
        billet: 'view_week',
        pix: 'pix',
      }

      const labelButtonPayment = {
        card: this.$t('steps.actionsLabels[0]'),
        billet: this.$t('steps.actionsLabels[1]'),
        pix: this.$t('steps.actionsLabels[2]'),
      }

      this.paymentTypeSelectedAction = paymentAction[payment]
      this.iconPayment.name = paymentButtonIcon[payment]
      this.labelButtonPayment = labelButtonPayment[payment]
    },
    paymentSelectedComponent(payment) {
      const paymentTypes = {
        card: PaymentCardOffer,
        billet: PaymentBillet,
        pix: PaymentPix,
        step: Payment,
      }

      if (this.orderBumpsQuantity === 0 && paymentTypes[payment] === PaymentCardOffer) {
        this.paymentTypeSelectedComponent = PaymentShopify
        this.hideNextStep = true
        return this.paymentTypeSelectedComponent
      }

      if (payment === 'card') {
        this.hideButtonActionPayment = false
        this.hideReturnStepPayment = true
      }

      this.paymentTypeSelectedComponent = PaymentShopify
      this.hideNextStep = true
      return payment
    },
    continuePaymentCard() {
      this.paymentTypeSelectedComponent = PaymentShopify
      this.hideButtonActionPayment = true
      this.hideReturnStepPayment = false
    },
    async paymentForCreditCard() {
      try {
        const validate = await this.$refs.payment.validateData()

        if (validate) {
          this.hideButtonActionPayment = false
          this.hideReturnStepPayment = false
          await this.paymentCardFinishPayment()
          this.handlePaymentResponse(this.paymentCardData)
        }
      } catch (error) {
        throw new Error(error)
      }
    },
    async paymentCardFinishPayment() {
      if (this.currentPaymentTypeSelected === 'card') {
        this.paymentTypeSelectedComponent = PaymentCardLoading

        try {
          await this.postCreateOrder()
          await this.postPaymentCard()
        } catch (error) {
          throw new Error(error)
        }
      }

      if (this.currentPaymentTypeSelected === 'billet') {
        try {
          await this.paymentForBillet()
          this.hideButtonActionPayment = false
          this.hideReturnStepPayment = true
        } catch (error) {
          throw new Error(error)
        }
      }

      if (this.currentPaymentTypeSelected === 'pix') {
        try {
          await this.paymentForPix()
          this.hideButtonActionPayment = false
          this.hideReturnStepPayment = true
        } catch (error) {
          throw new Error(error)
        }
      }
    },
    async paymentForBillet() {
      try {
        await this.validateCPFPaymentBilletAndPix()
        await this.postCreateOrder()
        await this.postPaymentBillet()
        this.hideButtonActionPayment = !this.hideButtonActionPayment
        this.hideReturnStepPayment = true
        this.handlePaymentResponse(this.stepsData.payment)
        return true
      } catch (error) {
        throw new Error(error)
      }
    },
    async paymentForPix() {
      try {
        await this.validateCPFPaymentBilletAndPix()
        await this.postCreateOrder()
        await this.postPaymentPix()
        this.hideButtonActionPayment = false
        this.hideReturnStepPayment = true
        this.handlePaymentResponse(this.stepsData.payment.pix)
        return true
      } catch (error) {
        throw new Error(error)
      }
    },
    returnStepShowText() {
      const returnStepText = {
        1: this.$t('steps.returnIndetifyStep'),
        2: this.$t('steps.returnAddressStep'),
        3: this.$t('return'),
      }

      this.returnStepText = returnStepText[this.currentStep]

      if (
        this.currentStep === 2 &&
        this.paymentTypeSelectedComponent === PaymentShopify &&
        this.currentPaymentTypeSelected === 'card'
      ) {
        this.returnStepText = returnStepText['3']
      }

      return this.currentStep > 0
    },
    returnStep() {
      this.disabledNextStep = false
      if (
        this.currentStep === 2 &&
        this.paymentTypeSelectedComponent === PaymentShopify &&
        this.currentPaymentTypeSelected === 'card'
      ) {
        this.paymentTypeSelectedComponent = Payment
        return true
      }

      if (this.currentStep > 0) {
        this.previousStep()
      }

      return this.currentStep
    },
    returnPaymentType() {
      this.paymentTypeSelectedComponent = PaymentShopify
      this.hideNextStep = false
      this.hideButtonActionPayment = true
      this.hideReturnStepPayment = false
    },
    returnPaymentCardDataPayment() {
      if (this.currentPaymentTypeSelected === 'card') {
        this.paymentTypeSelectedComponent = PaymentShopify
      }

      if (this.currentPaymentTypeSelected === 'billet') {
        this.paymentTypeSelectedComponent = PaymentShopify
      }

      if (this.currentPaymentTypeSelected === 'pix') {
        this.paymentTypeSelectedComponent = PaymentShopify
      }

      this.hideButtonActionPayment = true
      this.hideReturnStepPayment = false
    },
    returnPayment() {
      this.paymentTypeSelectedComponent = Payment
      this.hideNextStep = false
      this.iconPayment.name = 'local_mall'
      this.hideButtonActionPayment = true
    },
    reviewEditContact() {
      if (this.disabledNextStep) {
        this.disabledNextStep = false
      }
      this.returnStep()
    },
    reviewEditAdress() {
      if (this.disabledNextStep) {
        this.disabledNextStep = false
      }
      this.deliveryOrReviewData = Delivery
    },
    async actionsPostSteps() {
      const actionsPost = {
        2: () => false,
        next: () => this.nextStep(),
      }

      if (this.currentStep === 1 && this.deliveryOrReviewData === ReviewContactAddress) {
        actionsPost.next()
        return this.deliveryOrReviewData
      }

      if (this.currentStep === 2 && this.currentPaymentTypeSelected === 'billet') {
        actionsPost[2] = () => this.postPaymentBillet()
        this.paymentSelectedComponent(this.currentPaymentTypeSelected)
        return this.currentPaymentTypeSelected
      }

      if (this.currentStep === 2 && this.currentPaymentTypeSelected === 'card') {
        actionsPost[2] = () => this.postPaymentCard()
        this.paymentSelectedComponent(this.currentPaymentTypeSelected)
        return this.currentPaymentTypeSelected
      }

      if (this.currentStep === 2 && this.currentPaymentTypeSelected === 'pix') {
        actionsPost[2] = () => this.postPaymentPix()
        this.paymentSelectedComponent(this.currentPaymentTypeSelected)
        return this.currentPaymentTypeSelected
      }

      return (actionsPost[this.currentStep] || actionsPost.next)()
    },
    async nextPaymentForEnter() {
      const actionsEmittedForEnter = {
        Payment: () => this.$refs.payment.applyerCoupon(),
        PaymentCard: () => this.paymentForCreditCard(),
        PaymentBillet: () => this.paymentForBillet(),
        PaymentPix: () => this.paymentForPix(),
      }

      const currentComponenteName = this.paymentTypeSelectedComponent.name
      return actionsEmittedForEnter[currentComponenteName]()
    },
    async validateCPFPaymentBilletAndPix() {
      try {
        let validate = false

        if (
          this.currentPaymentTypeSelected === 'billet' ||
          this.currentPaymentTypeSelected === 'pix'
        ) {
          validate = await this.$refs.payment.validateData()
        } else {
          validate = true
        }

        return validate
      } catch (error) {
        throw new Error(error)
      }
    },
    async postPaymentBillet() {
      try {
        const validate = await this.validateCPFPaymentBilletAndPix()

        if (validate) {
          try {
            const cpf = this.replaceSpecialCharacters(this.stepsData.payment.document)
            const {
              data: { data: billetData },
            } = await this.paymentBilletShopify({ document: cpf })

            this.paymentTypeSelectedComponent = PaymentBilletSuccess
            this.stepsData.payment = billetData
            this.nextStep()
            return true
          } catch (error) {
            this.paymentTypeSelectedComponent = PaymentError
            this.hideButtonActionPayment = false
            this.hideReturnStepPayment = true
            throw new Error(error)
          }
        }

        return false
      } catch (error) {
        throw new Error(error)
      }
    },
    async postPaymentCard() {
      try {
        const cpf = this.replaceSpecialCharacters(this.stepsData.payment.document)
        const creditCardNumber = this.replaceSpecialCharacters(
          this.stepsData.payment.credit_card_number
        )

        const {
          data: { data: creditCardData },
        } = await this.paymentCreditCardShopify({
          ...this.stepsData.payment,
          installments: this.stepsData.payment.installments.id,
          credit_card_number: creditCardNumber,
          document: cpf,
        })

        this.iconPayment = null
        this.hideNextStep = true
        this.paymentTypeSelectedComponent = PaymentSuccess
        this.paymentCardData = creditCardData
        return true
      } catch (error) {
        this.paymentTypeSelectedComponent = PaymentError
        this.hideButtonActionPayment = false
        this.hideReturnStepPayment = true
        throw new Error(error)
      }
    },
    async postPaymentPix() {
      try {
        const validate = await this.validateCPFPaymentBilletAndPix()
        if (validate) {
          try {
            const cpf = this.replaceSpecialCharacters(this.stepsData.payment.document)
            const {
              data: { data: pix },
            } = await this.paymentPixShopify({ document: cpf })
            this.paymentTypeSelectedComponent = await PaymentPixSuccess
            this.stepsData.payment.pix = pix
            this.nextStep()
          } catch (error) {
            this.paymentTypeSelectedComponent = PaymentError
            this.hideButtonActionPayment = false
            this.hideReturnStepPayment = true
            throw new Error(error)
          }
        }

        return true
      } catch (error) {
        throw new Error(error)
      }
    },
    async postCreateOrder() {
      try {
        const paymentTypes = {
          card: 'CreditCard',
          billet: 'Boleto',
          pix: 'Pix',
        }

        await this.createOrderShopify({
          paymentType: paymentTypes[this.currentPaymentTypeSelected],
          telephone: this.stepsData.payment.telephone,
        })

        return true
      } catch (error) {
        return error
      }
    },
    getCurrentStepStatus() {
      const currentTypePayment =
        this.paymentTypeSelectedComponent === PaymentCard ||
        this.paymentTypeSelectedComponent === PaymentShopify ||
        this.paymentTypeSelectedComponent === PaymentBillet ||
        this.paymentTypeSelectedComponent === PaymentPix ||
        this.paymentTypeSelectedComponent === PaymentCardLoading ||
        this.paymentTypeSelectedComponent === PaymentBilletSuccess ||
        this.paymentTypeSelectedComponent === PaymentPixSuccess ||
        this.paymentTypeSelectedComponent === PaymentError ||
        this.paymentTypeSelectedComponent === PaymentSuccess

      const currentPaymentAndStep = this.currentStep === 2 && currentTypePayment

      if (currentPaymentAndStep) {
        this.SET_ENABLE_DISABLE_ADD_REMOVE_QUANTITY_BUNDLE(true)
        return true
      }

      return this.SET_ENABLE_DISABLE_ADD_REMOVE_QUANTITY_BUNDLE(false)
    },
    recaptchaAttemptsCount() {
      this.stepsData.payment.recaptcha_attempts += 1
      this.stepsData.payment.recaptcha_response = null
    },
  },
}
</script>

<style lang="scss" scoped>
.container__left {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  overflow: auto;
  background: $light-20;
  background: red;
  @include mobile {
    width: 100%;
    background: transparent;
    justify-content: flex-start;
  }
  @include tablet {
    width: 100%;
  }
  &__card {
    min-height: 350px;
    background: $white;
    background: green;
    width: 100%;
    height: 100%;
    @include mobile {
      min-height: min-content;
      margin-top: 60px;
      width: 100%;
    }
    @include tablet {
      width: 70%;
    }

    @include desktop {
      width: 50%;
      margin: 8% 0 0 0;
    }
  }

  .steps {
    padding: 10px;
    display: flex;
    flex-direction: row;
    list-style-type: none;
    justify-content: space-between;

    &__change-payment,
    &__return-step {
      margin: 15px 0 0 0;
      text-align: center;
      .steps__change-payment__return,
      .steps__return-step__return {
        cursor: pointer;
      }
    }

    &__return-step {
      margin: 17px 0 22px 0;
    }

    &__payment {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
    }

    &__content {
      margin: 0 16px 20px 16px;
      height: 100%;
      @include mobile {
        height: unset;
      }
    }

    .next {
      &:disabled {
        border: solid $dark-40 1px !important;
        ::v-deep {
          &.button-content .icon .am-icon .am-icon-material {
            color: $dark-40 !important;
            font-size: 20px;
          }
        }
      }
    }
  }

  .link {
    text-decoration: none;
  }

  .am-steps {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    background: purple;
    @include mobile {
      margin-bottom: 30px;
      height: unset;
      justify-content: flex-end;
    }
  }
}
</style>
